module.exports = __webpack_public_path__ + "img/table_black_v2.29ddef6b.svg";